module.exports = __webpack_public_path__ + "static/item3-f01ae4246501a75552de4c3370d5a9d2.svg";